'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* the controller allows components to listen for application events and respond and/or trigger new events.
* The current list of application events is:
*
* - icarus:form:retrieved
* - icarus:form:rendered
* - icarus:form:submitted
* - icarus:form:validated
* - icarus:form:saved
* - icarus:form:error
* - icarus:field:changed
* - icarus:field:validation_requested
* - icarus:field:validation_error
* - icarus:field:validation_fixed
* - icarus:field:validation_success
* - icarus:window:resize
* */
var IcarusController = function () {
    function IcarusController() {
        _classCallCheck(this, IcarusController);

        this._listeners = [];
    }

    _createClass(IcarusController, [{
        key: 'addListener',
        value: function addListener(events, cb) {
            var _this = this;

            events.split(',').forEach(function (event) {
                return _this._listeners.push({ event: event, cb: cb });
            });
        }
    }, {
        key: 'trigger',
        value: function trigger(event) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            this._listeners.filter(function (l) {
                return l.event === event;
            }).forEach(function (l) {
                return l.cb.apply(null, args);
            });
        }
    }, {
        key: 'listeners',
        get: function get() {
            return this._listeners;
        }
    }]);

    return IcarusController;
}();

exports.default = IcarusController;


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/controller.js
// module id = 210
// module chunks = 2 3